import imagesLoaded from 'imagesloaded';
export { generateLoaderMessage } from './quotes'

type ImagesLoadedInstance = {
    progressedCount: number;
    images: unknown[];
};

const IMAGE_CACHE_KEY = 'imagesLoaded';
const LOADER_SEEN_KEY = 'loaderSeen';
const LOAD_TIMEOUT_MS = 4000;

export const showLoader = async(incomingDocument: Document=document) => {
    incomingDocument.documentElement.dataset.loading = 'true';
    incomingDocument.getElementById('loader')?.classList.remove('hidden'); 
}

export const hideLoader = () => {
    document.documentElement.dataset.loading = 'false';
    setTimeout(() => {

        document.getElementById('loader')?.classList.add('hidden');
    }, 800)
}

export const isLoaderShowing = () => {
    return !document.getElementById('loader')?.classList.contains('hidden');
}

const updateProgressDisplay = (value: string) => {
    const progressValueEl = document.querySelector('.loader__progress-text') as HTMLElement

    if (progressValueEl)
        progressValueEl.innerText = value
}

export const isDataLoaded = () => {
    try {
        return sessionStorage.getItem(IMAGE_CACHE_KEY) === 'true';
    } catch {
        return false;
    }
}

export const hasSeenLoader = () => {
    try {
        return localStorage.getItem(LOADER_SEEN_KEY) === 'true';
    } catch {
        return false;
    }
}

const markLoaderSeen = () => {
    try {
        localStorage.setItem(LOADER_SEEN_KEY, 'true');
    } catch {
        return;
    }
}

const loadImages = async() => {
    return new Promise((resolve, reject) => {
        const mainContainer = document.getElementById('main')

        if (!mainContainer) {
            reject(new Error("Main Content wrapper not found"));
            return;
        }

        const imgLoad = imagesLoaded(mainContainer, { background: true });
        const timeoutId = window.setTimeout(() => {
            try {
                sessionStorage.setItem(IMAGE_CACHE_KEY, 'true');
            } catch {
                // Ignore storage write failures and continue showing content.
            }
            resolve('timeout');
        }, LOAD_TIMEOUT_MS);

        const cleanup = () => {
            window.clearTimeout(timeoutId);
        };

        imgLoad.on('progress', (instance: ImagesLoadedInstance) => {
            const percentComplete = Math.round((instance.progressedCount / instance.images.length) * 100);
            updateProgressDisplay(percentComplete.toString())
        })

        imgLoad.on('always', () => {
            cleanup();
            try {
                sessionStorage.setItem(IMAGE_CACHE_KEY, 'true');
            } catch {
                // Ignore storage write failures and continue showing content.
            }
            resolve('complete');
        })
        imgLoad.on('fail', (error: unknown) => {
            cleanup();
            reject(error)
        })
    })
}

export async function initImageLoader() {
    updateProgressDisplay("100")

    if (hasSeenLoader()) {
        hideLoader();
        return;
    }

    showLoader();

    if (!isDataLoaded()) {
        try {
            await loadImages();

        } catch(error) {
            console.error('Image loading failed: ', error)
        } finally {
            markLoaderSeen();
            hideLoader();

        }
    } else {
        markLoaderSeen();
        if (isLoaderShowing())
            hideLoader()
    }
}

